import client from "../client/client"

const fetchAuthStatus = async () => {
    const baseApiUrl = window.config?.baseApiUrl ?? null
    if (!baseApiUrl) return { isAuth: false, isAdmin: false }
    const authRes = await client.get(`${baseApiUrl}/auth/my`);
    const authData = await authRes.json();
    console.log('isAuth response: ' + authData.isAuth);
    const res = await client.get(`${baseApiUrl}/adminapi/claim/setClaims`)
    const data = await res.json();
    console.log("isAdmin response: " + data.isAdmin)
    return {
        isAuth: authData.isAuth,
        isAdmin: data.isAdmin,
    }
}

const authApi = {
    fetchAuthStatus,
}

export default authApi